import { match } from 'ts-pattern';
import { PowderCoatType } from '../__generated/model/index.js';
import { CabinetColor } from '../__generated/model/versions/v2.js';
export const migrateToV3 = (state)=>{
    return state.map((entity)=>{
        return match(entity).returnType().with({
            type: 'Room'
        }, ({ includeBurner, includeCabinets, includeGrill, includeHood, includeOtherCookingItem, includeRefrigerator, includeSink, cabinetColor, ...entity })=>({
                ...entity,
                powderCoatType: PowderCoatType.Anvil,
                cabinetColor: cabinetColor === CabinetColor.Stainless ? CabinetColor.Obsidian : cabinetColor
            })).otherwise((other)=>other);
    });
};

//# sourceMappingURL=v03.js.map